import DomainHandler from "../whitelabel/domainHandler";
import type { Plugin } from "vue";

const HostnamePlugin: Plugin = {
  install: (app) => {
    app.provide("getHostname", DomainHandler.getHostname);
  },
};

export default HostnamePlugin;
